import moment, { Moment } from 'moment';
import React from 'react';
import styled from 'styled-components';

import { colors, Option } from '../../../core';
import SelectInput from '../SelectInput';

interface SelectInputProps {
  defaultValue: any;
  onChange: (option: Option) => void;
  options: any;
}

interface YearMonthPickerProps {
  month: Moment;
  onMonthSelect: (currentMonth: Moment, newMonthVal: string) => void;
  onYearSelect: (currentMonth: Moment, newMonthVal: string) => void;
  futureYears?: number;
  onYearChange?: (date: Moment | null) => void;
  onMonthChange?: (date: Moment | null) => void;
}

const Layout = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  padding: 8px 22px;
`;

const StyledSelectInput = styled(SelectInput).attrs({
  variant: 'primary',
})<SelectInputProps>`
  .react-select {
    &__control {
      border: 0;

      &:hover {
        box-shadow: none;
      }
    }

    &__menu {
      border: 1px solid ${colors.cloud};
    }

    &__menu-list {
      max-height: 220px !important;
    }

    &__option {
      padding: 0 8px;
    }
  }
`;

const monthOptions = moment.months().map((label, value) => ({ label, value }));
const currentYear = moment().year();

const getMonthOption = (value: number) => monthOptions.find((opt) => opt.value === value);

const YearMonthPicker = ({
  month,
  onMonthSelect,
  onYearSelect,
  onYearChange,
  onMonthChange,
  futureYears = -100,
}: YearMonthPickerProps) => {
  const years = Math.abs(currentYear - (currentYear + futureYears));
  const yearOptions = Array(years)
    .fill('')
    .map((_, idx) => (futureYears < 0 ? currentYear - idx : currentYear + idx))
    .map((year) => ({ label: year, value: year }));

  const getYearOption = (value: number) => yearOptions.find((opt) => opt.value === value);

  return (
    <Layout>
      <StyledSelectInput
        defaultValue={getMonthOption(month.month())}
        onChange={({ value }: Option) => {
          onMonthSelect(month, value);
          const newDate = moment(month).set('month', +value);
          onMonthChange && onMonthChange(moment(newDate));
        }}
        options={monthOptions}
      />
      <StyledSelectInput
        defaultValue={getYearOption(month.year()) || { label: month.year(), value: month.year() }}
        onChange={({ value }: Option) => {
          onYearSelect(month, value);
          const newDate = moment(month).set('year', +value);
          onYearChange && onYearChange(moment(newDate));
        }}
        options={yearOptions}
      />
    </Layout>
  );
};

export default YearMonthPicker;
